import validations from '@unite-us/client-utils/dist/utils/validations';
var validateRequiredInput = function validateRequiredInput(value, validation) {
  var errMessage = validations.isRequired(value);
  return errMessage !== null && errMessage !== void 0 ? errMessage : validation(value);
};
export var validateEmail = function validateEmail(value) {
  return validateRequiredInput(value, validations.isEmail);
};
export var validatePhone = function validatePhone(value) {
  return validateRequiredInput(value, validations.isPhoneNumber);
};
//# sourceMappingURL=validateUtils.js.map